"use client";
import { useAuthQuery } from "@stadium/services/apollo-client";
import { useMemo } from "react";

import {
  fetchRewardUser,
  fetchWorkspacePoints,
} from "@stadium/checkout/src/graphql/queries/fetch-reward-points";
import { MY_WORKSPACE_SLUG } from "@stadium/constants";

const useFetchStadiumPoints = ({ skip = false } = {}) => {
  const { data, loading, refetch } = useAuthQuery(fetchRewardUser, {
    skip,
    fetchPolicy: "cache-and-network",
  });

  const rewardPoints = useMemo(() => {
    return loading ? 0 : data?.currentUser?.rewardPoints || 0;
  }, [loading, data]);

  return {
    rewardPoints,
    loading,
    refetch,
  };
};

export const useFetchWorkspacePoints = ({
  skip = false,
  workspaceSlug = MY_WORKSPACE_SLUG,
} = {}) => {
  const { data, loading, refetch } = useAuthQuery(fetchWorkspacePoints, {
    variables: {
      slug: workspaceSlug,
    },
    skip,
    fetchPolicy: "cache-and-network",
  });

  const rewardPoints = useMemo(() => {
    return loading ? 0 : data?.currentWorkspaceUser?.workspacePoints || 0;
  }, [loading, data]);

  return {
    rewardPoints,
    loading,
    refetch,
  };
};

export default useFetchStadiumPoints;
